// Sprint V102.ab (02.10.2026) — useQuestionSet()
// Bestimmt das aktive QuickCheck-Fragenset für die Landing-Page.
// Analog zu useHookVariant: Query > Cookie (30 Tage sticky) > Zufall (50/50).
//
// Werte:
//   "v1" — klassisches Likert-Set mit beruflich/privat-Switcher (bisheriges Set)
//   "v2" — Antreiber-Fokus-Set, Direktstart ohne Switcher, Q5 Forced-Choice
//
// URL-Override: ?questions=v1  oder  ?questions=v2
// Cookie-Name: f4s_question_set

import { useEffect, useState } from "react";

export const QUESTION_SETS = ["v1", "v2"];
const COOKIE_NAME = "f4s_question_set";
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30; // 30 Tage

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const raw = document.cookie || "";
  for (const part of raw.split(";")) {
    const [k, ...rest] = part.trim().split("=");
    if (k === name) return decodeURIComponent(rest.join("=") || "");
  }
  return null;
}

function writeCookie(name, value) {
  if (typeof document === "undefined") return;
  document.cookie =
    `${name}=${encodeURIComponent(value)}` +
    `; Max-Age=${COOKIE_MAX_AGE_SECONDS}` +
    `; Path=/` +
    `; SameSite=Lax`;
}

// 50/50-Split (Andreas-Direktive 02.10.2026 — schnelle Signifikanz).
// Falls Winner feststeht: analog Hook-D-Push später auf z. B. 10/90 drehen.
const SET_WEIGHTS = { v1: 0.5, v2: 0.5 };

function pickRandom() {
  const r = Math.random();
  let acc = 0;
  for (const k of QUESTION_SETS) {
    acc += SET_WEIGHTS[k] || 0;
    if (r < acc) return k;
  }
  return "v1"; // Safety net
}

/** Resolve the active question set using the priority: query > cookie > random. */
export function resolveQuestionSet() {
  if (typeof window === "undefined") return "v1";
  const params = new URLSearchParams(window.location.search || "");
  const q = (params.get("questions") || "").toLowerCase();
  if (QUESTION_SETS.includes(q)) {
    writeCookie(COOKIE_NAME, q);
    return q;
  }
  const c = (readCookie(COOKIE_NAME) || "").toLowerCase();
  if (QUESTION_SETS.includes(c)) return c;
  const rnd = pickRandom();
  writeCookie(COOKIE_NAME, rnd);
  return rnd;
}

export default function useQuestionSet() {
  const [set, setSet] = useState(() => {
    if (typeof window === "undefined") return "v1";
    return resolveQuestionSet();
  });
  useEffect(() => {
    setSet(resolveQuestionSet());
  }, []);
  return set;
}
